import { Box, Grid, MenuItem, Typography } from "@mui/material";
import { memo, useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import { FixedSizeList } from "react-window";
import Label from "../../../components/label";
import CustomDropDown from "../../../components/select";
import { AppContext } from "../../../lib/Context";

const generateOptions = () => {
  let options = [];
  for (let i = 0.5; i <= 115; i = i < 1 ? i + 0.5 : i + 1) {
    options.push(i);
  }
  return options;
};

const Upload = () => {
  const location = useLocation();
  const options = generateOptions();
  const [openMin, setOpenMin] = useState(false);
  const [openMax, setOpenMax] = useState(false);
  const { uploadSpeed, setUploadSpeed, userData } = useContext(AppContext);
  const isAdmin = userData?.designation === "Admin" ? true : false;
  const isDetailPage = location.pathname === "/prospect-details";

  const handleSelectOption = (type, value) => {
    setUploadSpeed((prev) => ({ ...prev, [type]: value }));
    // Close the dropdown after selection
    if (type === "min") setOpenMin(false);
    if (type === "max") setOpenMax(false);
  };

  const renderOption = ({ index, style }) => (
    <MenuItem
      key={index}
      style={style}
      onClick={() => handleSelectOption("min", options[index])}
    >
      {options[index]}
    </MenuItem>
  );

  const renderMaxOption = ({ index, style }) => (
    <MenuItem
      key={index}
      style={style}
      onClick={() => handleSelectOption("max", options[index])}
    >
      {options[index]}
    </MenuItem>
  );

  return (
    <Box mt={2} mb={5}>
      <Typography variant="h6" color={"text.charcoalGrey"}>
        Upload Speed
      </Typography>

      <Grid container mt={0} spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Minimum"} />
          <CustomDropDown
            variant={"filled"}
            value={uploadSpeed.min}
            renderValue={() => uploadSpeed.min}
            onOpen={() => setOpenMin(true)}
            onClose={() => setOpenMin(false)}
            open={openMin}
            readonly={isDetailPage}
          >
            <FixedSizeList
              height={200}
              width={300}
              itemSize={35}
              itemCount={options.length}
              itemData={options}
            >
              {renderOption}
            </FixedSizeList>
          </CustomDropDown>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Maximum"} />
          <CustomDropDown
            variant={"filled"}
            value={uploadSpeed.max}
            renderValue={() => uploadSpeed.max}
            onOpen={() => setOpenMax(true)}
            onClose={() => setOpenMax(false)}
            open={openMax}
            readonly={isDetailPage}
          >
            <FixedSizeList
              height={200}
              width={300}
              itemSize={35}
              itemCount={options.length}
              itemData={options}
            >
              {renderMaxOption}
            </FixedSizeList>
          </CustomDropDown>
        </Grid>
      </Grid>
    </Box>
  );
};

export default memo(Upload);
